import type { ReactNode } from "react";

import clsx from "clsx";

import type { ButtonSize } from "./";

import { ExportIcon } from "../Icons";
import { Button as ButtonV2 } from "./";

export type ExportCSVButtonProps = {
  label: ReactNode;
  onClick?: () => void;
  isLoading?: boolean;
  disabled?: boolean;
  icon?: ReactNode;
  showIcon?: boolean;
  size?: ButtonSize;
  className?: string;
  "data-testid"?: string;
};

const DefaultIcon = () => (
  <ExportIcon
    className="h-4 w-4"
    aria-hidden="true"
    data-testid="export_csv_button_default_icon"
  />
);

export const ExportCSVButton = ({
  label,
  onClick,
  isLoading = false,
  disabled,
  icon,
  showIcon = false,
  size = "md",
  className,
  "data-testid": testId,
}: ExportCSVButtonProps) => (
  <ButtonV2
    type="button"
    variant="tonal"
    size={size}
    onClick={onClick}
    isLoading={isLoading}
    disabled={disabled}
    iconL={icon ?? (showIcon ? <DefaultIcon /> : undefined)}
    className={clsx("w-fit shrink-0 whitespace-nowrap", className)}
    data-testid={testId}
  >
    {label}
  </ButtonV2>
);
